import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  exp: number; // Expiration time (in seconds since epoch)
}

export function isTokenExpired(token: string): boolean {
  try {
    //return true;
    const decoded = jwtDecode<DecodedToken>(token);
    //console.log("checking if token is expired:", decoded);
    const currentTime = Date.now() / 1000; // Convert to seconds
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true; // Treat invalid tokens as expired
  }
}

// Custom hook to monitor token expiration
export function useTokenExpiryCheck(token: string | null, onTokenExpired: () => void): void {
  useEffect(() => {
    if (!token) return;

    const checkInterval = setInterval(() => {
      if (isTokenExpired(token)) {
        clearInterval(checkInterval);
        onTokenExpired();
      }
    }, 5 * 1000); // Check every 5 seconds

    return () => clearInterval(checkInterval);
  }, [token, onTokenExpired]);
}
